import { useState } from 'react';
import { useI18n } from '@react/i18n';
import { Page, UserInput } from '../types';
import { UpdateUserInput } from '../VratkyApp';

interface Props {
    userInput: UserInput;
    update: UpdateUserInput;
    link: (page: Page) => void;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function KontaktniUdaje({ userInput, update, link }: Props) {
    const t = useI18n();
    const [error, setError] = useState<'name_missing' | 'email_missing' | 'email_invalid' | 'phone_missing' | null>(null);

    const checkAndMove = () => {
        if (!userInput.contact_name) {
            setError('name_missing');
        } else if (!userInput.contact_email) {
            setError('email_missing');
        } else if (!EMAIL_REGEX.test(userInput.contact_email)) {
            setError('email_invalid');
        } else if (!userInput.contact_phone) {
            setError('phone_missing');
        } else {
            link('summary');
        }
    };

    return (
        <div className="vr-step">
            <h3>{t('Kontaktní údaje')}</h3>

            <div className="vr-field">
                <label>{t('Jméno')}<span className="vr-required">*</span></label>
                <input type="text" className="form-control" value={userInput.contact_name} onChange={(e) => update('contact_name', e.target.value)} placeholder="..." />
            </div>
            <div className="vr-field">
                <label>{t('Email')}<span className="vr-required">*</span></label>
                <input type="text" className="form-control" value={userInput.contact_email} onChange={(e) => update('contact_email', e.target.value.trim())} placeholder={t('jmeno@domena.cz')} />
            </div>
            <div className="vr-field">
                <label>{t('Telefon')}<span className="vr-required">*</span></label>
                <input type="text" className="form-control" value={userInput.contact_phone} onChange={(e) => update('contact_phone', e.target.value)} placeholder="+420 xxx xxx xxx" />
            </div>

            {error === 'name_missing' && !userInput.contact_name && (
                <div className="vr-alert vr-alert--danger" role="alert">{t('Prosím vyplňte kontaktní jméno.')}</div>
            )}
            {error === 'phone_missing' && !userInput.contact_phone && (
                <div className="vr-alert vr-alert--danger" role="alert">{t('Prosím vyplňte kontaktní telefon.')}</div>
            )}
            {error === 'email_missing' && !userInput.contact_email && (
                <div className="vr-alert vr-alert--danger" role="alert">{t('Prosím vyplňte kontaktní email.')}</div>
            )}
            {error === 'email_invalid' && Boolean(userInput.contact_email) && (
                <div className="vr-alert vr-alert--danger" role="alert">{t('Zadejte platný email ve formátu jmeno@domena.cz')}</div>
            )}

            <div className="vr-actions">
                <button type="button" className="vr-btn vr-btn--secondary" onClick={() => link('form')}>{t('Zpět')}</button>
                <button type="button" className="vr-btn vr-btn--primary" onClick={checkAndMove}>{t('Pokračovat')}</button>
            </div>
        </div>
    );
}
